import Vue from "vue";
import Grid from "simple-xgrid";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
import "simple-xgrid/dist/simple-grid.css";

Vue.use(Grid);
